import { useEffect, useState } from 'react';
import { ProgramWizardBatteryConfig, ProgramWizardData } from '../ProgramWizard.types';
import ConfirmStepContent from './ConfirmStepContent';

type StepConfirmProps = {
  wizardData: ProgramWizardData;
  getBatteryConfig: () => Promise<ProgramWizardBatteryConfig>;
};

const StepConfirm = ({ wizardData, getBatteryConfig }: StepConfirmProps) => {
  const [batteryConfig, setBatteryConfig] = useState<ProgramWizardBatteryConfig>({});

  useEffect(() => {
    getBatteryConfig().then((config) => {
      if (config) {
        setBatteryConfig((state) => ({ ...state, ...config }));
      }
    });
  }, [getBatteryConfig]);

  return <ConfirmStepContent wizardData={wizardData} configData={batteryConfig} />;
};

export default StepConfirm;
